import styled from 'styled-components'

export const PostTagWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
`
export const PostTag = styled.a<{ tagType?: string }>`
  padding: 0.5rem 0.5rem;
  margin: 0.2rem 0.2rem;
  border-radius: 100px;
  background: #ffffff;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }

  & span {
    color: ${({ tagType }) => {
      switch (tagType) {
        //case 'Sustainability':
        //  return '#19C896'
        case 'Energy Efficiency':
          return '#3538CD'
        case 'Ecological Materials':
          return '#3538CD'
        case 'Environmentally Friendly':
          return '#F96E48'
        case 'Waste Reduction':
          return '#CD3584'
        case 'Renewable Resources':
          return '#5019C8'
        case 'Renewable Energy':
          return '#5019C8'
        case 'Circular Economy':
          return '#199FC8'
        case 'Green Technology':
          return '#45CD35'
        case 'Eco-friendly Packaging':
          return '#C8191C'
        case 'Water Conservation':
          return '#ABC819'
        default:
          return '#000000' // Default to black or customize
      }
    }};
  }

  background: ${({ tagType }) => {
    switch (tagType) {
      //case 'Sustainability':
      // return '#F0F9FF'
      case 'Energy Efficiency':
        return '#EEF4FF'
      case 'Ecological Materials':
        return '#EEF4FF'
      case 'Environmentally Friendly':
        return '#FFFAF6'
      case 'Waste Reduction':
        return '#FFEEF7'
      case 'Renewable Resources':
        return '#F7F0FF'
      case 'Renewable Energy':
        return '#F7F0FF'
      case 'Circular Economy':
        return '#F0FDFF'
      case 'Green Technology':
        return '#F3FFEE'
      case 'Eco-friendly Packaging':
        return '#FFF0F1'
      case 'Water Conservation':
        return '#F7FFF0'
      default:
        return '#d9d9d9' // Default to black or customize
    }
  }};
`
